import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Route, Link, withRouter, Redirect } from "react-router-dom"
import LoadingOverlay from "./general/loadingOverlay"
import Overlay from "./general/overlay"
import { loadingStatus, setActiveProperties, getPayload, setViewAs } from "../actions"
import settings from "settings"

import Dashboard from "containers/salesManager/dashboard"
import LotInventory from "containers/salesManager/lot-inventory"
import Paperwork from "containers/salesManager/paperwork"
import Account from "./general/account"
import LotStatus from "./reports/lotStatus"
import WeeklySummary from "containers/admin/weeklySummary"
import ReactSelect from "components/ReactSelect"
import Competition from "./entry/competition"
import { compose } from "redux"
import Demographics from "containers/reports/demographics"
import Geographics from "containers/reports/marketingGeographics"
import axios from "axios"
import _ from "lodash"
import helpers from "helpers/helpers"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import PropertySelect from "components/PropertySelect"
import ViewAs from "components/ViewAs"
import currentUser from "helpers/currentUser"
import Floorplans from "./entry/floorplans"
import Floorplan from "./entry/floorplan"
import WeeklyReport from "./reports/weekly"
var jwtDecode = require("jwt-decode")

class SalesManager extends Component {
	constructor(props) {
		super(props)
		this.user = currentUser()
		this.state = {
			invalid: false, // making sure managers can't login to entry section
			noActivityModal: false,
			viewAs: false,
			viewAsID: 0,
			nav: [
				{
					title: "DASHBOARD",
					icon: "fa-tachometer-alt",
					link: "/salesManager/dashboard",
				},
				...(settings?.disabled?.managerDemographics
					? []
					: [
							{
								title: "DEMOGRAPHICS",
								icon: "fa-family",
								link: "/salesManager/demographics",
							},
					  ]),
				...(settings?.disabled?.managerGeographics
					? []
					: [
							{
								title: "GEOGRAPHICS",
								icon: "fa-radar",
								link: "/salesManager/geographics",
							},
					  ]),
				{
					title: "LOT INVENTORY",
					icon: "fa-usd-circle",
					link: "/salesManager/lot-inventory",
				},
				{
					title: "LOT MAP",
					icon: "fa-map-marked-alt",
					link: "/salesManager/lot-status",
				},
				{
					title: "WEEKLY ACTIVITY",
					icon: "fad fa-pencil-alt",
					link: "/salesManager/weekly-summary",
				},
				{
					title: "WEEKLY REPORT",
					icon: "fa-calendar-week",
					link: "/salesManager/weekly-report",
				},
			],
		}

		if (!settings.disablePaperwork) {
			this.state.nav.push({
				title: "BUYER PAPERWORK",
				icon: "fas fa-file-alt",
				link: "/salesManager/paperwork",
			})
		}
	}

	componentDidMount() {
		// Check that this is a salesperson and not a manager

		var user = localStorage.getItem("user")
		user = jwtDecode(user)
		let activeProperties = localStorage.getItem("activeProperties")
		if (activeProperties) {
			this.props.setActiveProperties(JSON.parse(activeProperties))
		}
		if (localStorage.getItem("viewAs")) {
			let sp = jwtDecode(localStorage.getItem("viewAs"))
			this.props.setViewAs(sp.id)
		}
		/* if (user.aud !== 1) {
            localStorage.removeItem("user")
            this.setState({ invalid: true })
            return
        } */
		this.props.getPayload()
	}

	renderNav() {
		// use the third array item to determine where we are in the entry section
		var pathArray = window.location.pathname.split("/")
		var classNames = require("classnames")
		let nav = _.cloneDeep(this.state.nav)
		if (settings.optionManagerModules && settings.optionManagerModules.length > 0) {
			nav = _.concat(nav, settings.optionManagerModules)
		}
		let sm = _.find(this.props.payload.users, { id: this.user.id })
		if (sm?.paperwork_only) {
			nav = [
				{
					title: "BUYER PAPERWORK",
					icon: "fas fa-file-alt",
					link: "/salesManager/paperwork",
				},
			]
		}
		return nav.map((r, i) => {
			var path = r.link.split("/")
			var here = path[2] == pathArray[2] ? true : false
			var classes = classNames("body__navItem", {
				here: here,
			})
			return (
				<li key={i} className={classes}>
					<Link to={r.link}></Link>
					<div className="body__navTitle">
						<i className={`fas ${r.icon} fa-2x`}></i>
						<span>{r.title}</span>
					</div>
				</li>
			)
		})
	}

	backtoAdmin = () => {
		localStorage.removeItem("viewAs")
		this.props.setViewAs(0)
	}

	changeUser = (v) => {
		var userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: v, activeProperties: this.props.activeProperties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
				// Check what the person they want to view as is.
				let find = _.find(this.props.payload.users, { id: v })
				let viewAsID = find ? find.group : null
				this.props.setViewAs(v)
				this.setState({ viewAs: true, viewAsID })
				this.props.getPayload()
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	viewAsBack = () => {
		if (localStorage.getItem("viewAs")) {
			let url = localStorage.getItem("currentPath") ? localStorage.getItem("currentPath") : "/"
			return (
				<li onClick={this.backtoAdmin}>
					<Link to={url}>Back to Admin</Link>
				</li>
			)
		}
	}

	viewAsName = () => {
		if (localStorage.getItem("viewAs")) {
			let salesperson = _.find(this.props.payload.public.salespeople, { id: this.props.viewAs })
			if (!salesperson) {
				return
			}
			return (
				<span className="viewAs__name">
					Viewing as: {salesperson.first} {salesperson.last}
				</span>
			)
		}
	}

	viewAsSelect = () => {
		if (localStorage.getItem("viewAs")) {
			return (
				<li>
					<div className="top__viewAs">
						<p className="top__selectTitle">View As:</p>
						<ViewAs
							options={helpers.listViewAsUsers(
								this.props.payload.users,
								this.props.payload.public.builders,
								this.props.activeProperties
							)}
							value={this.props.viewAs}
							onChange={(v) => this.changeUser(v)}
							onBlur={() => {}}
							className="top__select"
							classNamePrefix="multiSelect"
							clearable
						/>
					</div>
				</li>
			)
		}
	}

	requestHelp = () => {
		if (localStorage.getItem("viewAs")) {
			//return
		}
		if (!this.props.payload.salespersonPayload.help) {
			return
		}
		return (
			<>
				<p className="portal__help">
					Need help?
					<br />
				</p>
				<p className="portal__help">
					<a href={`mailto:${this.props.payload.salespersonPayload.help}`}>REQUEST HELP</a>
				</p>
			</>
		)
	}

	listProperties = (v) => {
		let user = currentUser()
		if (user.viewAs) {
			user.activeProperties = user.availableProperties
		}
		let arr = []
		if (
			this.props.payload.public.properties.length > 0 &&
			user.activeProperties &&
			typeof user.activeProperties == "object" &&
			user.activeProperties.length > 0
		) {
			// The trackers are to keep track of which metro and metro sub groups this user has access to.
			let individuals = []
			let metro = []
			let metroTracker = [] // the metro areas this person has access to via their property assignemtns
			let metro_sub = []
			let metro_subTracker = [] // and the subs they have access to ^
			_.forEach(this.props.payload.public.properties, (v) => {
				if (user.activeProperties.includes(v.id)) {
					individuals.push({
						value: v.id,
						label: v.name,
						metroGroup: v.metro_group,
						metroSubGroup: v.metro_sub_group,
					})
					metroTracker.push(v.metro_group)
					metro_subTracker.push(v.metro_sub_group)
				}
			})
			metroTracker = _.compact(_.uniq(metroTracker))
			metro_subTracker = _.compact(_.uniq(metro_subTracker))

			individuals = _.sortBy(individuals, "label")
			//return individuals

			arr.push({
				label: "Individual Properties",
				options: individuals,
			})
			// Now add in groups
			_.forEach(this.props.payload.public.metro, (v) => {
				if (metroTracker.includes(v.id) && v.show == 1) {
					// this user has access to a property in this metro
					metro.push({
						value: `Metro-` + v.id,
						label: v.name,
						group: v.id,
						metro: true,
					})
				}
			})
			if (metro.length > 0) {
				arr.push({
					label: "Metro Areas",
					options: metro,
					isMetro: true,
				})
			}
			// Now add in metro sub groups
			_.forEach(this.props.payload.public.metroSub, (v) => {
				if (metro_subTracker.includes(v.id) && v.show == 1) {
					// this user has access to a property in this metro
					metro_sub.push({
						value: `MetroSub` + v.id,
						label: v.name,
						group: v.id,
						metroSub: true,
					})
				}
			})
			if (metro_sub.length > 0) {
				arr.push({
					label: "Metro Sub Areas",
					options: metro_sub,
					isMetroSub: true,
				})
			}
		}

		if (user.modules && user.modules[0] == "*") {
			arr.push({
				label: "All Properties",
				options: [{ value: "*", label: "Company Wide" }],
				isMetroSub: true,
			})
		}

		return arr
	}

	getNewToken = async (properties) => {
		let userToken = localStorage.getItem("user")
		await axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: this.props.viewAs, activeProperties: properties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
			})
	}

	changeProperties = async (v) => {
		if (!v) {
			v = []
		}
		let f = []
		for (let r of v) {
			f.push(r)
		}
		if (f.length == 0) {
			localStorage.removeItem("activeProperties")
		} else {
			localStorage.setItem("activeProperties", JSON.stringify(f))
		}
		this.props.setActiveProperties(f)
		// If this is a viewAs, we need to get a new token because getData pulls the viewas token which has active props.
		if (this.props.viewAs) {
			let sp = jwtDecode(localStorage.getItem("viewAs"))
			if (sp && Array.isArray(sp.activeProperties)) {
				sp.activeProperties = v
				await this.getNewToken(f)
			}
		}
		this.props.getPayload()
	}

	inputNoActivity = () => {
		submitData("inputNoActivity")
			.then((data) => {
				toast.success(data.message)
				this.setState({ noActivityModal: false })
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	emailCommunityManagers = () => {
		if (this.props.payload.salesManagerPayload.communityManagers) {
			return (
				<a
					className="portal__communityManagers"
					href={`mailto:${this.props.payload.salesManagerPayload.communityManagers}`}>
					Need Help? Email Us
				</a>
			)
		}
	}

	displayInterface = () => {
		return (
			<div className="globalCont c">
				<div className="top">
					<div className="top__logo">
						<Link to="/salesManager/dashboard">
							<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
						</Link>
					</div>
					<div className="top__global">
						<div className="top__propertyPicker">
							<p className="top__selectTitle">Active Properties:</p>
							<PropertySelect
								isMulti
								options={this.listProperties()}
								value={this.props.activeProperties}
								onChange={(f) => this.changeProperties(f)}
								onBlur={() => {}}
								className="top__select"
								classNamePrefix="multiSelect"
								clearable
							/>
						</div>
						<div>
							<ul className="top__globalList">
								{this.viewAsBack()}
								{this.viewAsSelect()}
								{/*<li><i className="far fa-bell"></i></li>*/}
								<li>
									<Link to="/salesManager/account">
										<i className="far fa-user-cog"></i>
									</Link>
								</li>
								<li>
									<Link to="/logout">
										<i className="far fa-power-off"></i>
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="body">
					<div className="body__nav">
						<ul className="body__navList">{this.renderNav()}</ul>
						<div className="portal__sideNav">{this.emailCommunityManagers()}</div>
					</div>
					<div className="body__stageCont">
						<div className="body__stage" id="stage">
							<Route path="/salesManager/account" exact component={Account} />
							<Route path="/salesManager/dashboard" exact component={withRouter(Dashboard)} />
							<Route path="/salesManager/lot-inventory" exact component={withRouter(LotInventory)} />
							<Route path="/salesManager/paperwork" exact component={Paperwork} />
							<Route path="/salesManager/competition" exact component={Competition} />
							<Route path="/salesManager/lot-status" exact component={LotStatus} />
							<Route path="/salesManager/weekly-summary" exact component={WeeklySummary} />
							<Route path="/salesManager/weekly-report" exact component={WeeklyReport} />
							<Route path="/salesManager/floorplans" exact component={Floorplans} />
							<Route path="/salesManager/floorplan/:id" component={Floorplan} />
							<Route path="/salesManager/demographics" exact component={Demographics} />
							<Route path="/salesManager/geographics" exact component={Geographics} />
						</div>
					</div>
				</div>
				<p className="body__issues">
					Issues or comments? Email us at <a href={`mailto:${settings.issueEmail}`}>{settings.issueEmail}</a>{" "}
					| <a href="https://www.pipsy.io">Pipsy</a> | Master Planned Community Engine | Made in Texas
				</p>
				<LoadingOverlay />
				<Overlay />
			</div>
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (this.state.viewAs) {
			// Go through and check what type of user this is
			if (this.state.viewAsID === 14) {
				return <Redirect to={`/arc`} />
			} else if (this.state.viewAsID === 13) {
				return <Redirect to={`/entry/dashboard`} />
			} else if (this.state.viewAsID === 15) {
				return <Redirect to={`/superintendent/lot-inventory`} />
			}
			return this.displayInterface()
		} else {
			return this.displayInterface()
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		payload: state.payload,
		viewAs: state.viewAs,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
			setViewAs,
			setActiveProperties,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(SalesManager)
